import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "../../contexts/ThemeModeContext";
import { ToggleButton } from "./ThemeModeToggle.styles";

const SunIcon: FC = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z" />
  </svg>
);

const MoonIcon: FC = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3a9 9 0 109 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 01-4.4 2.26 5.403 5.403 0 01-3.14-9.8c-.44-.06-.9-.1-1.36-.1z" />
  </svg>
);

const ThemeModeToggle: FC = () => {
  const { t } = useTranslation("common");
  const { resolvedTheme, mode, setMode } = useThemeMode();

  const handleClick = () => {
    // Cycle: light -> dark -> system -> light
    if (mode === "light") {
      setMode("dark");
    } else if (mode === "dark") {
      setMode("system");
    } else {
      setMode("light");
    }
  };

  const getTitle = () => {
    const label = t("account.theme");
    if (mode === "system") return `${label}: ${t("account.themeSystem")}`;
    if (mode === "dark") return `${label}: ${t("account.themeDark")}`;
    return `${label}: ${t("account.themeLight")}`;
  };

  const title = getTitle();

  return (
    <ToggleButton onClick={handleClick} title={title} aria-label={title}>
      {resolvedTheme === "dark" ? <MoonIcon /> : <SunIcon />}
    </ToggleButton>
  );
};

export default ThemeModeToggle;
